import React, { useMemo } from 'react'

import { ApolloProvider } from '@apollo/client'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'
import enGB from 'date-fns/locale/en-GB'
import { IntlProvider } from 'react-intl'

import { Alert, muiTheme, muiThemeClarity, ThemeProvider } from '@acre/design-system'
import { ErrorProvider, flattenMessages, getMessages, Locales, useFlag } from '@acre/utils'

import initApollo from './graphql/initApollo'
import messages from './intl/messagesBrokerCrm'
import { GlobalStyle } from './index.styles'

const flattenedMessages = flattenMessages(getMessages(messages, Locales.GB))

type Props = {
  children: JSX.Element
}

const AppProviders = ({ children }: Props) => {
  const client = useMemo(initApollo, [])
  const scoreFont = useFlag('feature.score_font', false)

  return (
    <LocalizationProvider adapterLocale={enGB} dateAdapter={AdapterDateFns}>
      <IntlProvider locale={Locales.GB} messages={flattenedMessages}>
        <ApolloProvider client={client}>
          <ThemeProvider theme={scoreFont ? muiThemeClarity : muiTheme}>
            <ErrorProvider alertSlot={Alert}>
              <GlobalStyle />
              {children}
            </ErrorProvider>
          </ThemeProvider>
        </ApolloProvider>
      </IntlProvider>
    </LocalizationProvider>
  )
}
export default AppProviders
